import isEmpty from "is-empty";
import React, { useEffect, useState } from "react";
import { getCivilitiesQuery } from "rsl-api-106/lib/queries";
import { Query, QueryGetCivilitiesArgs } from "rsl-api-106/lib/types";

import { useQuery } from "@apollo/client";
import { useSession } from "@hooks";

import { SelectOptionType } from "../../../../types";
import Select from "../Select";
import { SelectProps } from "../Select/Select";

interface SelectCivilityProps extends SelectProps {
  //
}

const languagesVarsCodes = [
  "LANG_neobooking_civility_choose", //Choisir une civilité
  "LANG_neobooking_civility_loading", //Chargement des civilités...
];

const SelectCivility: React.FC<SelectCivilityProps> = ({ ...props }) => {
  /* Hooks */
  const { sessionId, getLanguageVarValue } = useSession();
  const { data, error, loading } = useQuery<Query, QueryGetCivilitiesArgs>(
    getCivilitiesQuery(),
    {
      variables: { session: { name: sessionId!! } },
    }
  );

  /* State */
  const [civilitiesOptions, setCivilitiesOptions] = useState<
    SelectOptionType[]
  >([]);

  useEffect(() => {
    if (data && data.getCivilities?.civilitiyList) {
      const options: SelectOptionType[] =
        data.getCivilities.civilitiyList
          ?.filter(
            (x) =>
              x?.code?.toLowerCase() === "m" ||
              x?.code?.toLowerCase() === "mm" ||
              x?.code?.toLowerCase() === "cie"
          )
          ?.map((x) => {
            return {
              value: x?.code as string,
              label: x?.label as string,
            };
          }) ?? [];
      setCivilitiesOptions(options);
    }
  }, [data]);

  return (
    <>
      <Select
        placeholder={
          props.placeholder
            ? props.placeholder
            : getLanguageVarValue("LANG_neobooking_civility")
        }
        loadingPlaceholder={
          props.loadingPlaceholder
            ? props.loadingPlaceholder
            : getLanguageVarValue("LANG_neobooking_civility_loading")
        }
        empty={civilitiesOptions && isEmpty(civilitiesOptions)}
        {...props}
        options={civilitiesOptions}
        style={{
          color: props.value && !isEmpty(props.value) ? "black" : "#a3a3a3",
        }}
      />
    </>
  );
};

SelectCivility.propTypes = {
  //
};

export default SelectCivility;
